const FIVE_MINUTES_MS = 5 * 60 * 1000

export type FrontOfficeQueryOptions = { gcTime?: number }

export const frontOfficeQueryOptions = { gcTime: FIVE_MINUTES_MS } satisfies FrontOfficeQueryOptions
